const tl = {
  meta: { code: "tl", label: "Tagalog" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Mga Pagsusuri",
    mypage: "Aking Pahina",
    login: "Mag-login",
    register: "Mag-sign up",
    logout: "Mag-logout",
  },
  hero: {
    eyebrow: "Plataporma ng pagsusuri",
    title: "Tuklasin ang iyong sarili sa pamamagitan ng pagsusuri",
    subtitle1: "Pag-iisip, personalidad, at kakayahan — buong-buong nakikita",
    subtitle2: "Tingnan ang iyong lakas at kahinaan sa loob ng 5 minuto",
    subtitle3: "Bawat pagsusuri ay nagiging datos mo",
    cta_primary: "Magsimula ng pagsusuri",
    cta_secondary: "Tingnan ang katalogo",
    disclaimer: "Sanggunian / Hindi medikal",
  },
  categories: {
    ability: "Kakayahan",
    personality: "Personalidad",
    mental: "Mental",
    aptitude: "Hilig",
    traits: "Katangian",
  },
  catalog: {
    title: "Lahat ng Pagsusuri",
    subtitle: "17 pagsusuri / 5 kategorya",
    filter_all: "Lahat",
    duration: "min",
    difficulty: { easy: "Madali", medium: "Katamtaman", hard: "Mahirap" },
    question_count: "tanong",
    start: "Simula",
  },
  quiz: {
    question: "Tanong",
    of: "/",
    next: "Susunod",
    prev: "Bumalik",
    submit: "Tingnan ang resulta",
    progress: "Pag-usad",
    exit: "Lumabas",
    required: "Pumili ng sagot",
    submitting: "Inilalapat ang puntos…",
  },
  result: {
    overall: "Pangkalahatang puntos",
    type_label: "Uri",
    share_link: "Ibahagi ang resulta sa link",
    back_to_catalog: "Sumubok ng iba",
    view_mypage: "Tingnan ang kasaysayan sa Aking Pahina",
    premium_title: "I-unlock ang detalyadong pagsusuri",
    premium_subtitle: "Sa premium, makikita mo ang lahat sa ibaba:",
    feature_breakdown: "Detalyadong breakdown ng puntos",
    feature_cause: "Ugat na pagsusuri",
    feature_plan: "Plano para sa pagpapabuti",
    feature_pdf: "PDF report (A4)",
    price: "¥980",
    price_note: "(Ligtas na pagbabayad sa Stripe)",
    price_free: "Libre",
    price_free_note: "(Limitadong oras · 100% libre)",
    unlock_button: "Magbayad gamit ang Stripe",
    unlock_button_free: "I-unlock nang libre",
    unlock_requires_auth: "Mag-login muna upang i-unlock",
    unlock_save_first: "I-save muna ang resulta sa account",
    unlocking: "Iniredirect sa Stripe…",
    free_only_notice: "Libre lamang ang pangkalahatang puntos at uri.",
    compliance_note:
      "Ang pagsusuri na ito ay sanggunian lamang at hindi medikal na diagnosis. Iniiwasan namin ang pananakot o tiyak na pananalita.",
  },
  premium: {
    title: "Detalyadong report ng pagsusuri",
    summary: "Pangkalahatang buod",
    strengths: "Lakas",
    weaknesses: "Lugar ng pag-unlad",
    improvements: "Plano sa pagpapabuti",
    dimensions: "Puntos sa bawat dimensyon",
    download_pdf: "I-download ang PDF",
    pdf_soon: "Pag-export ng PDF (paparating)",
  },
  mypage: {
    title: "Aking Pahina",
    subtitle: "Iyong kasaysayan, takbo ng puntos, at mga badge",
    total: "Kabuuang pagsusuri",
    average: "Karaniwang puntos",
    premium_count: "Naka-unlock",
    categories_covered: "Mga kategorya",
    trend_title: "Takbo ng puntos",
    history_title: "Kasaysayan",
    badges_title: "Mga badge",
    unlock_3_title: "I-unlock ang Composite Analysis",
    unlock_3_desc: "Sumubok pa ng {n} upang i-unlock ang composite analysis",
    unlocked: "Na-unlock ang composite analysis",
    no_history: "Walang pagsusuri pa — sumubok na ngayon.",
  },
  auth: {
    login_title: "Mag-login",
    register_title: "Gumawa ng account",
    email: "Email",
    password: "Password (hindi bababa sa 6 char)",
    name: "Display name (opsyonal)",
    login_btn: "Mag-login",
    register_btn: "Mag-sign up",
    go_register: "Walang account? Mag-sign up",
    go_login: "May account na? Mag-login",
    anon_note: "Libre at anonymous ang pagsusuri. Account lang ang kailangan kapag mag-save o magbabayad.",
    success_register: "Nalikha ang account",
    success_login: "Naka-login na",
    consent_section: "Pahintulot",
    consent_required: "Tanggapin ang mga kinakailangang item",
    accept_terms_pre: "Sumasang-ayon ako sa",
    terms_link: "Mga Tuntunin ng Serbisyo",
    accept_terms_post: "",
    accept_privacy_pre: "Nabasa ko na ang",
    privacy_link: "Patakaran sa Privacy",
    accept_privacy_post: "at pumapayag sa pagproseso ng aking personal na datos",
    accept_age: "Ako ay 16 taong gulang pataas (o may pahintulot ng tagapag-alaga)",
    accept_marketing: "Magpadala sa akin ng email tungkol sa mga bagong pagsusuri at promo",
    optional: "opsyonal",
  },
  landing: {
    status_online: "SYSTEM ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 PAGSUSURI",
    status_langs: "14 WIKA",
    status_ai: "AI · ON",
    title_line1: "Tuklasin ang iyong sarili",
    title_line2: "sa loob ng 5 minuto.",
    trust_diagnostics: "PAGSUSURI",
    trust_languages: "WIKA",
    trust_per_test: "BAWAT TEST",
    hud_readout: "PANGUNAHING BASA",
    hud_score_unit: "/100 KABUUAN",
    hud_band: "ANTAS · GOLD",
    hud_dimensions: "DIMENSYON",
    hud_dimensions_status: "3 / 3 LIVE",
    hud_syslog: "LOG NG SISTEMA",
    cat_eyebrow: "// KATEGORYA",
    cat_title_pre: "5 kategorya · ",
    cat_title_highlight: "17 pagsusuri",
    view_all: "Tingnan lahat",
    proto_eyebrow: "// PROTOCOL",
    proto_title_pre: "I-unlock ang iyong sarili ",
    proto_title_highlight: "sa 3 hakbang.",
    step1_title: "Pumili ng test",
    step1_body: "Pumili sa 17 test. Anonymous na simula.",
    step2_title: "Sagot sa 5 minuto",
    step2_body: "Progress bar + badges para mag-momentum.",
    step3_title: "I-unlock ng AI",
    step3_body: "Detalyadong puntos, plano at PDF.",
    final_eyebrow: "// HANDA NA?",
    final_title_pre: "Ang iyong sarili ",
    final_title_highlight: "sa 5 minuto.",
    final_subtitle: "Tingnan ang iyong lakas at kahinaan sa loob ng 5 minuto",
    final_button: "Magsimula na",
  },
  footer: {
    tagline: "Plataporma ng pagsusuri ng pag-iisip, personalidad, at hilig",
    rights: "Lahat ng karapatan ay nakalaan.",
    legal: "Legal",
    privacy: "Privacy",
    terms: "Tuntunin",
    about_label: "Tungkol / Kumpanya",
    compliance_label: "Pagsunod Pang-internasyonal",
    tokushoho_label: "Batas Pangkalakal ng Hapon",
    data_protection_label: "Proteksyon ng Datos (Internasyonal)",
    data_request_label: "Burahin ang Datos / Opt-out",
    disclaimer_label: "Disclaimer",
    disclaimer_full:
      "Ang serbisyong ito ay sanggunian lamang at hindi medikal na diagnosis. Hindi kami gumagamit ng nakakatakot o tiyak na pananalita.",
  },
  badges: {
    "first-diagnosis": "Unang Pagsusuri",
    "three-diagnostics": "3 Pagsusuri",
    "five-diagnostics": "5 Pagsusuri",
    "ten-diagnostics": "10 Pagsusuri",
    "high-performer": "High Performer",
    "premium-user": "Premium User",
  },
  lang_selector: "Wika",
  payment: {
    processing_title: "Sinusuri ang bayad…",
    processing_subtitle: "Bumalik mula sa Stripe — bumubuo ng detalyadong pagsusuri (hanggang 20s)",
    success: "Nakumpirma ang bayad — naka-unlock ang premium",
    expired: "Nag-expire ang checkout. Pakisubukang muli.",
    error: "Hindi ma-verify ang bayad. Makipag-ugnayan sa support.",
  },
};
export default tl;
